import script from "./BankStatementTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BankStatementTable.vue?vue&type=script&setup=true&lang=js"

import "./BankStatementTable.vue?vue&type=style&index=0&id=622330f4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-622330f4"]])

export default __exports__